import { EnvironmentService } from '../environment.service';
import { ScriptsLazyLoaderService, Scripts } from '../scripts-lazy-loader.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { Renderer2 } from '@angular/core';

export abstract class ThirdPartyBase {
  protected isInitializedSubject: BehaviorSubject<boolean> =
    new BehaviorSubject<boolean>(false);

  constructor(
    protected scriptsLazyLoaderService: ScriptsLazyLoaderService,
    protected environmentService: EnvironmentService,
    protected scripts: Scripts,
  ) {}

  isInitialized(): Observable<boolean> {
    return this.isInitializedSubject;
  }

  abstract init(renderer2: Renderer2): void;
}
